export const Internet = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.9999 4.5917C7.90845 4.5917 4.5917 7.90845 4.5917 11.9999C4.5917 16.0913 7.90845 19.408 11.9999 19.408C16.0913 19.408 19.408 16.0913 19.408 11.9999C19.408 7.90845 16.0913 4.5917 11.9999 4.5917ZM2.57129 11.9999C2.57129 6.7926 6.7926 2.57129 11.9999 2.57129C17.2071 2.57129 21.4284 6.7926 21.4284 11.9999C21.4284 17.2071 17.2071 21.4284 11.9999 21.4284C6.7926 21.4284 2.57129 17.2071 2.57129 11.9999Z'
        fill='#200000'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.8074 6.38935C10.3079 7.77688 9.97945 9.76038 9.97945 11.9999C9.97945 14.2393 10.3079 16.2228 10.8074 17.6104C11.0587 18.3084 11.3342 18.802 11.5895 19.1019C11.8482 19.4059 11.9908 19.408 11.9999 19.408C12.0089 19.408 12.1515 19.4059 12.4102 19.1019C12.6655 18.802 12.941 18.3084 13.1923 17.6104C13.6918 16.2228 14.0203 14.2393 14.0203 11.9999C14.0203 9.76038 13.6918 7.77688 13.1923 6.38935C12.941 5.6913 12.6655 5.19774 12.4102 4.89781C12.1515 4.59384 12.0089 4.5917 11.9999 4.5917C11.9908 4.5917 11.8482 4.59384 11.5895 4.89781C11.3342 5.19774 11.0587 5.6913 10.8074 6.38935ZM10.0509 3.58829C10.5174 3.04028 11.1721 2.57129 11.9999 2.57129C12.8277 2.57129 13.4824 3.04028 13.9488 3.58829C14.4187 4.14034 14.7962 4.87963 15.0933 5.705C15.6907 7.36433 16.0407 9.59001 16.0407 11.9999C16.0407 14.4097 15.6907 16.6354 15.0933 18.2947C14.7962 19.1201 14.4187 19.8594 13.9488 20.4114C13.4824 20.9594 12.8277 21.4284 11.9999 21.4284C11.1721 21.4284 10.5174 20.9594 10.0509 20.4114C9.58105 19.8594 9.20354 19.1201 8.90641 18.2947C8.30905 16.6354 7.95904 14.4097 7.95904 11.9999C7.95904 9.59001 8.30905 7.36433 8.90641 5.705C9.20354 4.87963 9.58105 4.14034 10.0509 3.58829Z'
        fill='#200000'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.3264 13.0101H4.19435V10.9897H11.3264V13.0101Z'
        fill='#200000'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.4182 13.0101H18.7346V10.9897H20.4182V13.0101Z'
        fill='#200000'
      />
      <path
        d='M10.6933 10.9897V13.0101H12.0403L12.7137 10.9897H10.6933Z'
        fill='#200000'
      />
      <path
        d='M19.408 13.0101V10.9897H18.0611L17.3876 13.0101H19.408Z'
        fill='#200000'
      />
    </svg>
  );
};
